import React from 'react'
import classNames from 'classnames'

import styles from './Spinner.module.css'

const Spinner = ({ className = '' }) => <div className={classNames(styles.spinner, className)} />

export default Spinner
